module.exports = "/dashboard/modal-announcement-b48dc1.html";